import React, { useEffect, useState, useRef } from 'react';
import partnerSellingPoint1 from '../../assets/images/partner/partner_selling_point_1.png';
import partnerSellingPoint2 from '../../assets/images/partner/partner_selling_point_2.png';
import partnerSellingPoint3 from '../../assets/images/partner/partner_selling_point_3.png';
import partnerArrow from '../../assets/images/partner/partner_arrow.png';

function PartnerSellingPoint() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-[#340065] py-24 md:py-32 overflow-hidden">
      <div className="bg-[#340065] w-full flex flex-col items-center justify-center px-4 md:px-[80px] space-y-[80px] md:space-y-[120px]">
        {/* 상단 타이틀 섹션 */}
        <div className={`bg-[#340065] text-center mb-[20px] md:mb-0 space-y-4 transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <p className="text-[20px] md:text-[24px] font-pretendard font-normal text-white leading-[160%]">지금 선택해야 할 렌즈 판매 파트너, 폰피쉬</p>
          <h2 className="text-[28px] md:text-[40px] font-pretendard font-bold text-white leading-[140%]">
            매출과 트렌드,<br className="block md:hidden" /> 둘 다 잡는 렌즈 판매 솔루션
          </h2>
        </div>

        {/* 3개의 판매 포인트 */}
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-[100px] md:gap-8 md:gap-[140px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          {/* 첫 번째 포인트 */}
          <div className="flex flex-col items-center">
            <div className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] md:mb-[10px] mb-8 md:mb-0 relative">
              <img src={partnerSellingPoint1} alt="고객 유입 & 매출 UP" className="w-full h-full object-contain drop-shadow-lg" />
            </div>
            <h3 className="text-[22px] md:text-[30px] font-bold text-white mb-4 md:mb-0 text-center">
              고객 유입 & 매출 <span className="text-[#00FFBF]">UP</span>
            </h3>
            <p className="text-[16px] md:text-[20px] font-pretendard font-semibold text-black leading-[160%] text-center bg-white rounded-full shadow-[0_4px_8px_rgba(0,0,0,0.1),inset_0_2px_4px_rgba(0,0,0,0.1)] px-6 py-3">
              렌즈 체험 → 매장 방문 → 매출 상승!
            </p>
          </div>

          {/* 두 번째 포인트 */}
          <div className="flex flex-col items-center">
            <div className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] md:mb-[10px] mb-8 md:mb-0 relative">
              <img src={partnerSellingPoint2} alt="초기 비용 ZERO" className="w-full h-full object-contain drop-shadow-lg" />
            </div>
            <h3 className="text-[22px] md:text-[30px] font-bold text-white mb-4 md:mb-0 text-center">
              초기 비용 <span className="text-[#00FFBF]">ZERO</span>
            </h3>
            <p className="text-[16px] md:text-[20px] font-pretendard font-semibold text-black leading-[160%] text-center bg-white rounded-full shadow-[0_4px_8px_rgba(0,0,0,0.1),inset_0_2px_4px_rgba(0,0,0,0.1)] px-6 py-3">
              등록만 하면 바로 시작, 비용 부담 無
            </p>
          </div>

          {/* 세 번째 포인트 */}
          <div className="flex flex-col items-center">
            <div className="w-[180px] h-[180px] md:w-[200px] md:h-[200px] md:mb-[10px] mb-8 md:mb-0 relative">
              <img src={partnerSellingPoint3} alt="렌즈 업무 부담 NO" className="w-full h-full object-contain drop-shadow-lg" />
            </div>
            <h3 className="text-[22px] md:text-[30px] font-bold text-white mb-4 md:mb-0 text-center">
              렌즈 업무 부담 <span className="text-[#00FFBF]">NO</span>
            </h3>
            <p className="text-[16px] md:text-[20px] font-pretendard font-semibold text-black leading-[160%] text-center bg-white rounded-full shadow-[0_4px_8px_rgba(0,0,0,0.1),inset_0_2px_4px_rgba(0,0,0,0.1)] px-6 py-3">
              운영은 폰피쉬가, 고객은 매장에서
            </p>
          </div>
        </div>

        {/* 하단 스크롤 인디케이터 */}
        <div className={`transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'} -mt-400`}>
          <div className="w-[65px] h-[35px] md:w-[130px] md:h-[70px] relative flex items-center justify-center">
            <img
              src={partnerArrow}
              alt="스크롤"
              className="w-full h-full animate-scrollDown"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartnerSellingPoint; 